import { getSubDomain } from "utils/helperFunctions";
import { trackVIScheduleDemoClicked } from "utils/trackingFunctions";

export const getScheduleDemoUrl = (
  isFreeTrial,
  rep,
  utmParams,
  numberOfEmployees
) => {
  const { content, campaign, source, medium } = utmParams;

  const isAU = getSubDomain() === "app-au";
  const useScheduleOnceName = !isAU && !isFreeTrial;

  const firstName = rep?.sdr?.firstName.replace(/[^a-zA-Z]/g, "").toLowerCase();
  const lastName = rep?.sdr?.lastName.replace(/[^a-zA-Z-]/g, "").toLowerCase();

  const targetEvent = isFreeTrial ? "/criteria-platform-discussion" : "";

  const utmParametersLink = `?utm_content=${content}&utm_campaign=${campaign}&utm_source=${source}&utm_medium=${medium}`;

  if (isFreeTrial && firstName === "sales" && lastName === "team") {
    // If NA, use direct Calendly link based on number of employees
    if (!isAU && numberOfEmployees) {
      if (numberOfEmployees?.includes("-")) {
        const [minEmployees, maxEmployees] = numberOfEmployees
          .split("-")
          .map(Number);

        if (minEmployees >= 0 && maxEmployees <= 250) {
          return `https://calendly.com/d/cq7j-tyk-nsk/criteria-platform-discussion-sb${utmParametersLink}`;
        }

        if (minEmployees >= 251 && maxEmployees <= 1000) {
          return `https://calendly.com/d/cntx-ty9-fx2/criteria-platform-discussion-mm${utmParametersLink}`;
        }
      }

      return `https://calendly.com/d/cnz3-5n8-7yb/criteria-platform-discussion-enterprise${utmParametersLink}`;
    }

    const criteriaNameLink = isAU
      ? "criteria-ashley-bramble"
      : `criteria-${firstName}-${lastName}`;

    return `https://calendly.com/${criteriaNameLink}${targetEvent}${utmParametersLink}`;
  }

  // if rep is not sales team and is a free trial, use the sales rep link
  if (isFreeTrial) {
    return `https://calendly.com/criteria-${firstName}-${lastName}${targetEvent}${utmParametersLink}`;
  }

  // If NA Subscriber, use direct AM Calendly link
  // Only AM's in NA use direct Calendly
  if (useScheduleOnceName && rep.am.scheduleOnceName) {
    return `${rep.am.scheduleOnceName}${utmParametersLink}`;
  }

  return `https://calendly.com/d/${isAU ? "ckkp-rmk-9d7" : "cpz5-vqp-qq6"}/subscription-add-on`;
};

export const getScheduleDevelopDemoUrl = (rep, utmParams) => {
  const { content, campaign, source, medium } = utmParams;
  const isAU = getSubDomain() === "app-au";

  if (rep.csm.firstName && rep.csm.lastName) {
    const firstName = rep.csm.firstName.replace(/[^a-zA-Z]/g, "").toLowerCase();
    const lastName = rep.csm.lastName.replace(/[^a-zA-Z-]/g, "").toLowerCase();

    return `https://calendly.com/criteria-${firstName}-${lastName}?utm_content=${content}&utm_campaign=${campaign}&utm_source=${source}&utm_medium=${medium}`;
  }
  return `https://calendly.com/d/${isAU ? "ckkp-rmk-9d7" : "cpz5-vqp-qq6"}/subscription-add-on`;
};

export const handleScheduleVIDemo = (
  trackingSource,
  isFreeTrial,
  rep,
  utmParams,
  numberOfEmployees = false
) => {
  trackVIScheduleDemoClicked(trackingSource);

  const url = getScheduleDemoUrl(
    isFreeTrial,
    rep,
    utmParams,
    numberOfEmployees
  );

  window.open(url, "_blank");
};
